<div class="carousel-wrapper" [ngClass]="{ 'is-mobile': isMobile }">
  <app-property-list-label
    *ngIf="property"
    [property]="property"
  ></app-property-list-label>
  <div class="current">
    {{ currentSlide }}/{{ this.property?.images?.length || 0 }}
  </div>

  <swiper-container
    #swiper
    (afterinit)="swiperReady()"
    (slidechange)="slideChangeHandler($event)"
    [ngClass]="{ 'is-mobile': isMobile }"
  >
    <swiper-slide
      *ngFor="let item of items; let i = index; trackBy: trackByFn"
      lazy="true"
      (click)="handleImageClick()"
    >
      <img
        [attr.src]="item.small.url"
        [attr.data-srcset]="
          item.small.url + ' 600w, ' + item.medium.url + ' 1200w'
        "
        alt="property image"
        [style]="{ height }"
        class="medium"
        loading="lazy"
      />
      <div class="swiper-lazy-preloader"></div>
    </swiper-slide>
  </swiper-container>

  <div class="navigation" *ngIf="swiper">
    <div class="prev-button" (click)="goPrev()"></div>
    <div class="next-button" (click)="goNext()"></div>
  </div>

  <div *ngIf="property" class="types" (click)="handleImageClick()">
    <div class="property-type">
      {{ property.type | stringTransform: 'capitalizeFirstLetter' }}
    </div>
    <div class="property-type subtype">
      {{ property.subType | stringTransform: 'capitalizeFirstLetter' }}
    </div>
  </div>

  <ng-container *ngIf="isLoggedIn">
    <app-property-share-button
      (handleOpen)="toggleShareModal()"
    ></app-property-share-button>
    <app-property-share-modal
      [open]="shareModalOpen"
      (handleClose)="toggleShareModal()"
      [property]="property"
    ></app-property-share-modal>
  </ng-container>
</div>

<div #lightGalleryRef class="hidden" *ngIf="property">
  <lightgallery
    [settings]="gallerySettings"
    class="space-y-6"
    [onInit]="onGalleryInit"
  >
    <a *ngFor="let item of items" class="item block" [href]="item.medium.url">
      <img
        loading="lazy"
        [src]="item.medium.url"
        [alt]="
          property.houseNumber
            ? property.houseNumber +
              ' ' +
              property.street +
              ' - ' +
              property.city +
              ' ' +
              property.state
            : 'Sign in to full address - ' +
              property.city +
              ' ' +
              property.state
        "
      />
    </a>
  </lightgallery>
</div>
